import { AccordionSummary, Grid, Typography } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import InputBase from '@material-ui/core/InputBase';
import Paper from '@material-ui/core/Paper';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MaterialTable from 'material-table';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../../services/api';
import { findPermission } from '../../../../services/auth';
import useStyles from '../style';
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import Loading from '../../../../components/Loading';
import { FilterStatusHeader } from './FilterStatusHeader';
import { canShowEdit } from '../../../../utils/functions';

export function BankAccount({ providerId, isEditing, isRural = false }) {
  const classes = useStyles();

  const [bankAccount, setBankAccount] = useState([]);
  const [status, setStatus] = useState('ativo');
  const [isLoading, setLoading] = useState(false);

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        localization={{
          body: {
            emptyDataSourceMessage: <span></span>,
          },
        }}
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        onRowClick={(event, rowData) => {
          if(!!findPermission(2763, 'Alterar') && canShowEdit()) {
            window.location.href = window.location.origin + `/app/fornecedor/${providerId}/conta-bancaria/${rowData.fornecedorContaBancariaId}/editar`
          }
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Rede',
            field: 'ancora',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Banco',
            field: 'banco',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 10px',
            },
          },
          {
            title: 'Agência',
            field: 'agencia',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (rowData) =>
              rowData.agencia + (rowData?.agenciaDigito ? '-' + rowData?.agenciaDigito : ''),
          },
          {
            title: 'Conta',
            field: 'conta',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
            render: (rowData) =>
              rowData.conta + (rowData?.contaDigito ? '-' + rowData?.contaDigito : ''),
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            disableClick: true,
            render: (rowData) => (
              <>
                {!!findPermission(2763, 'Consultar') && (
                  <Link
                    className={classes.buttonVisualize}
                    to={`/app/fornecedor/${providerId}/conta-bancaria/${rowData.fornecedorContaBancariaId}`}
                  >
                    <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                  </Link>
                )}
                {!!findPermission(2763, 'Alterar') && canShowEdit() && (
                  <Link
                    className={classes.buttonEdit}
                    to={`/app/fornecedor/${providerId}/conta-bancaria/${rowData.fornecedorContaBancariaId}/editar`}
                  >
                    <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                  </Link>
                )}
              </>
            ),
          },
        ]}
        data={bankAccount}
      />
    ),
    [bankAccount],
  );

  const fetchProviderBankAccount = async () => {
    setLoading(true);
    const res = await api.get(
      `/FornecedoresContasBancarias/ConsultarGridCadastro?fornecedorId=${providerId}&${
        status ? `status=${status}` : ''
      }`,
    );
    res.data.resposta?.[0]?.key === 'Notificacao' || res.data.resposta?.[0]?.key === ''
      ? setBankAccount([])
      : setBankAccount(res.data.resposta);
    setLoading(false);
  };

  useEffect(() => {
    if (providerId && !isRural) {
      fetchProviderBankAccount();
    }
  }, [providerId]);

  return (
    <Accordion defaultExpanded>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
        <Typography className={classes.heading}>Contas Bancárias</Typography>
      </AccordionSummary>

      <AccordionDetails className={classes.details}>
        <Grid container>
          {!isRural && (
            <Grid item xs={12} className={classes.registerBtn}>
              <FilterStatusHeader
                fetchFunc={fetchProviderBankAccount}
                status={status}
                setStatus={setStatus}
              />
              {isEditing && !!findPermission(2763, 'Cadastrar') && (
                <Link
                  className={classes.button}
                  to={`/app/fornecedor/${providerId}/cadastrar-conta-bancaria`}
                >
                  Novo Item
                </Link>
              )}
            </Grid>
          )}

          {isLoading ? (
            <Loading />
          ) : (
            <Grid item xs={12}>
              {isRural ? (
                <Typography className={classes.heading}>Produtor Rural</Typography>
              ) : (
                memoizedTable
              )}
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
